export default "__VITE_ASSET__63115a09__"